export default __webpack_public_path__ + "static/media/casal_6.6232e4d2.jpg";